export default __webpack_public_path__ + "static/media/Tiger's Boots of Stalking Fury.3afc16b2.jpg";